import React from "react"
import { Row, Col, Dropdown } from "react-bootstrap"
import { selectDocument } from "../../redux/actions"
import { useDispatch } from "react-redux"
import Dropzone from "../dropzone"
import * as Constants from "../../common/constants"

const RequiredDocuments = ({ uiData }) => {
  const {
    proofDocuments,
    claimUploadListModel,
    pageNumber,
    tempBenefitInfo,
    coverageHeaderList,
    hideHeaderFooter,
    lockUploadDropdown,
  } = uiData

  const previewsContainer = "DocumentPreviewContainer"
  const dispatch = useDispatch()

  let coverageDetailList = []

  coverageHeaderList.forEach((headerListItem, headerListKey) => {
    headerListItem.CoverageDetails.forEach((detailListItem, detailListKey) => {
      coverageDetailList.push(detailListItem)
    })
  })

  const DropdownValueChange = (documentId, documentDesc) => {
    dispatch(selectDocument(documentId, documentDesc))
  }

  const checkDocumentStatus = documentId => {
    var hasExists = claimUploadListModel.filter(doc => {
      return (
        doc.coverageDetailId === tempBenefitInfo.CoverageDetailId &&
        doc.documentId === documentId
      )
    })

    return hasExists.length > 0
  }

  const countUploadedDocument = (coverageDetailId, coverageCode) => {
    var uploadedList = claimUploadListModel.filter(doc => {
      return doc.coverageDetailId === coverageDetailId
    })

    if (pageNumber === Constants.policyInfoPageNumber) {
      return false
    }

    return (
      uploadedList.length > 0 ||
      tempBenefitInfo.CoverageDetailId === coverageDetailId
      // || coverageDetailId === Constants.basicCoverageDetailId
    )
  }

  const createDocumentsList = () => {
    let documentsArray = []
    proofDocuments.map((item, key) => {
      documentsArray.push(
        <Row
          key={key}
          className="mt-3 paddingLeft15px paddingRight15 unsetMarginTopBottom"
        >
          <Col
            xs={12}
            md={12}
            className={
              "marginTop10px CheckBox documentUpload" +
              (checkDocumentStatus(item.documentId)
                ? " documentSelectedText"
                : "")
            }
          >
            <div>
              {item.description +
                " - " +
                (item.mandatory ? "Required" : "Optional")}
            </div>
          </Col>
        </Row>
      )

      return null
    })
    return documentsArray
  }

  const createDocumentsDropdownList = () => {
    let documentsDropdownArray = []
    proofDocuments.map((item, key) => {
      documentsDropdownArray.push(
        <Dropdown.Item
          key={key}
          onClick={DropdownValueChange.bind(
            this,
            item.documentId,
            item.description
          )}
          className={
            "dropdown-item DropdownItem AddTripDocumentClass " +
            (lockUploadDropdown ? "disabled" : "")
          }
        >
          {item.description}
        </Dropdown.Item>
      )

      return null
    })
    return documentsDropdownArray
  }

  return (
    <>
      <div>
        <Row
          className={
            pageNumber === Constants.benefitRequiredDocumentPageNumber
              ? ""
              : "hide"
          }
        >
          <div
            className={
              "title text-center " +
              (pageNumber === Constants.benefitRequiredDocumentPageNumber
                ? ""
                : "hide") +
              " " +
              (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
            }
          >
            Upload supporting documents
          </div>
          <Row className={"containerBody marginTop3x"}>
            <Col
              xs={{ span: 12, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              className="formContainer"
            >
              <div
                className={
                  "horizontal-align marginBottom1x " +
                  (pageNumber === Constants.benefitRequiredDocumentPageNumber
                    ? ""
                    : "hide")
                }
              >
                <Col xs={12} md={12}>
                  <div className={"titleText "}>Claim documents</div>
                </Col>
              </div>
              <div className="formNoteSection marginBottom19px">
                <span className="highlight-text">PLEASE NOTE:</span> Etiqa’s
                Representatives may contact you and request to present to Etiqa
                the certified copy of the documents.
              </div>
              {coverageDetailList.map(
                (coverageDetailItem, coverageDetailKey) => (
                  <div
                    key={coverageDetailKey}
                    className={
                      coverageDetailItem.CoverageDetailId ===
                      tempBenefitInfo.CoverageDetailId
                        ? ""
                        : "hide"
                    }
                  >
                    <Row>
                      <p className="DescriptionTxt">
                        Below is a list of minimum documentation required to
                        process your claim. Additional information may be
                        required for further assessment.
                        <br />
                      </p>
                    </Row>
                    {createDocumentsList()}
                    <br />
                    <Row>
                      <p className="DescriptionTxt">
                        <span className="note-title">NOTE:&nbsp;</span>
                        <span className="note">
                          Please attach address proof in .jpg, .png, .jpeg, .pdf
                          format only not more than 10MB
                        </span>
                      </p>
                    </Row>
                    <Row className="mt-5 paddingLeft15px paddingRight15">
                      <Col
                        xs={12}
                        md={12}
                        className="SupportingDocumentsUploadArea"
                      >
                        <div className="mt-2">
                          {countUploadedDocument(
                            coverageDetailItem.CoverageDetailId,
                            coverageDetailItem.CoverageCode
                          ) && (
                            <>
                              <Row>
                                <p className="DescriptionTxt">
                                  Select document name
                                </p>
                                <Dropdown className="dropdown col-10">
                                  <Dropdown.Toggle
                                    id="dropdown-basic"
                                    className="btn btn-secondary dropdown-toggle DropdownHeader"
                                  >
                                    {uiData.tempSelectedDocument.documentDesc}
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className="dropdown-menu DropdownMenu">
                                    {createDocumentsDropdownList()}
                                  </Dropdown.Menu>
                                </Dropdown>

                                <Dropzone
                                  uiData={uiData}
                                  previewsContainer={
                                    coverageDetailItem.CoverageCode +
                                    previewsContainer
                                  }
                                />
                              </Row>

                              <Row>
                                <div
                                  id={
                                    coverageDetailItem.CoverageCode +
                                    previewsContainer
                                  }
                                  style={{
                                    width: "auto !important",
                                    border: "transparent !important",
                                    display: "contents",
                                  }}
                                  className={"dropzone "}
                                ></div>
                              </Row>
                            </>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )
              )}
            </Col>
          </Row>
        </Row>
      </div>
    </>
  )
}

export default RequiredDocuments
